import { TriggerType } from '@pushly/models/lib/enums/journeys'

export interface ITriggerFlags {
    isSubscribed: boolean
    isAbandonedCart: boolean
    isAbandonedView: boolean
    isAbandonment: boolean
    isSavedItem: boolean
}

/**
 * Centralizes common trigger-type boolean checks used in rendering logic.
 * Pure utility with no side effects.
 */
export function getTriggerFlags(triggerType?: TriggerType): ITriggerFlags {
    const isSubscribed = triggerType === TriggerType.SUBSCRIBED
    const isAbandonedCart = triggerType === TriggerType.ABANDONED_CART
    const isAbandonedView = triggerType === TriggerType.ABANDONED_VIEW
    const isAbandonment = isAbandonedCart || isAbandonedView
    const isSavedItem = triggerType === TriggerType.SAVED_ITEM

    return {
        isSubscribed,
        isAbandonedCart,
        isAbandonedView,
        isAbandonment,
        isSavedItem,
    }
}
